import React from "react";
import LegalDocument from "../components/legal/LegalDocument";

const TermsOfUse = () => {
  return <LegalDocument type="terms" />;
};

export default TermsOfUse;
